import React, {FunctionComponent} from "react";
import {useIntl} from "react-intl";
import {useNavigate} from "react-router-dom";
import {BankAccount} from "../../../interfaces/BankAccountInterface";
import {SELF_PROFILE_PATH} from "../../../constants/routes/RoutePaths";
import GenericModal from "./GenericModal";
import FieldLabel from "../../atoms/FieldLabel";

interface ModalVerifyBankAccountBeforeInvoiceProps {
  open: boolean;
  onOpen: (open: boolean) => void;
  defaultBankAccount?: BankAccount;
  onConfirm: () => void;
}

const ModalVerifyBankAccountBeforeInvoice: FunctionComponent<ModalVerifyBankAccountBeforeInvoiceProps> = ({
  open,
  onOpen,
  defaultBankAccount,
  onConfirm,
}) => {
  const intl = useIntl();
  const navigate = useNavigate();

  const handleCorrect = () => {
    onOpen(false);
    navigate(SELF_PROFILE_PATH);
  };

  return (
    <GenericModal
      title={intl.formatMessage({id: "modal_verify_bank_account_title"})}
      open={open}
      onOpen={onOpen}
      closable
      footer={{
        primaryAction: {
          buttonLabel: intl.formatMessage({id: "modal_verify_bank_account_confirm"}),
          action: onConfirm,
        },
        secondaryAction: {
          buttonLabel: intl.formatMessage({id: "modal_verify_bank_account_correct"}),
          action: handleCorrect,
        },
      }}
    >
      <p>{intl.formatMessage({id: "modal_verify_bank_account_body"})}</p>
      {defaultBankAccount ? (
        <div className="d-flex flex-column gap-2 mt-3">
          {defaultBankAccount.accountTitle && (
            <FieldLabel
              label={intl.formatMessage({id: "bank_account_title"})}
              value={defaultBankAccount.accountTitle}
            />
          )}
          <FieldLabel
            label={intl.formatMessage({id: "bank_account_name"})}
            value={defaultBankAccount.accountName}
          />
          <FieldLabel
            label={intl.formatMessage({id: "bank_iban_code"})}
            value={defaultBankAccount.ibanCode}
          />
          <FieldLabel
            label={intl.formatMessage({id: "bank_bic_code"})}
            value={defaultBankAccount.bicCode}
          />
          <FieldLabel
            label={intl.formatMessage({id: "bank_name"})}
            value={defaultBankAccount.bankName}
          />
        </div>
      ) : (
        <p className="text-muted mt-2">
          {intl.formatMessage({id: "modal_verify_bank_account_no_account"})}
        </p>
      )}
    </GenericModal>
  );
};

export default ModalVerifyBankAccountBeforeInvoice;
